import { AbTestConfiguration } from '@pubstack/common/src/abTest'
import { Button } from '@pubstack/ui/components/Button'
import { GlobalModalWrapper } from '@pubstack/ui/components/GlobalModalWrapper'
import { Actions, Body, Title } from '@pubstack/ui/components/ModalLayout'
import { FunctionComponent } from 'react'
import { useGlobalModal } from '~/components/layout/GlobalModal'

type ActivateAbTestModalProps = { abTest?: AbTestConfiguration; onToggle: () => void; navigateToView?: () => void }

export const ActivateAbTestModal: FunctionComponent<ActivateAbTestModalProps> = ({ abTest, onToggle, navigateToView }) => {
  const { close } = useGlobalModal()
  return (
    <GlobalModalWrapper>
      <Title>Activate {abTest?.name}</Title>
      <Body className="flex flex-col gap-3">
        <p className="flex flex-col">
          <span>Only one A/B test can be live at the same time.</span>
          <span>If you activate this test, the current A/B test will be disabled.</span>
        </p>
      </Body>
      <Actions>
        <Button
          onClick={async () => {
            await close()
            navigateToView?.()
          }}
          variant="tertiary"
          trackingLabel="common-settings-ab-test-activation-cancel"
        >
          Keep current test enabled
        </Button>
        <Button
          onClick={() => {
            onToggle()
            return close()
          }}
          trackingLabel="common-settings-ab-test-activation-confirm"
        >
          Activate A/B test
        </Button>
      </Actions>
    </GlobalModalWrapper>
  )
}
